export const PAYMENT_FEEDBACK_SHOWN = "payment_feedback_shown";
export const PAYMENT_FEEDBACK_DEEPLINK = "swiggy://externalWidget?banner_type=WEBVIEW&card_type=HALF_CARD&url={0}";
export const PAYMENT_FEEDBACK_URL =
    "https://webviews.swiggy.com/feedback/payment_feedback.html?context=PaymentFeedback";
